<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	let { config }: { config: BrandConfig } = $props();

	// Default values for Artificer Innovations, LLC
	const defaultWebsiteUrl = 'artificerinnovations.com';
	const defaultBrandNameRelationship = 'Artificer Innovations, LLC';

	// Use brand value for websiteUrl, or legalIntroSettings override, or fall back to default
	const websiteUrl = config.legalIntroSettings?.websiteUrl ?? config.brand ?? defaultWebsiteUrl;
	const brandNameRelationship = config.legalIntroSettings?.brandNameRelationship ?? defaultBrandNameRelationship;
</script>

<div class="legal-intro">
	<p>
		These Terms of Service apply to <strong>{websiteUrl}</strong> and all other websites and brands operated by Artificer Innovations, LLC. This website is operated by <strong>{brandNameRelationship}</strong>. References to "Company," "we," "our," or "us" refer to Artificer Innovations, LLC regardless of which brand website you are accessing.
	</p>
</div>

<style>
	.legal-intro {
		margin-bottom: 0;
	}

	.legal-intro p {
		font-size: 1rem;
		line-height: 1.6;
		color: var(--text-color);
		margin: 0 0 1rem 0;
	}

	.legal-intro strong {
		color: var(--accent-color);
		font-weight: 600;
	}
</style>
